const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

export default function SolutionSection() {
  return (
    <section className="w-full bg-luxury-black py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="reveal">
            <span className="font-sans text-gold text-xs tracking-luxury uppercase">
              Çözüm
            </span>
          </div>
          <h2 className="reveal reveal-delay-1 font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light mt-5 leading-snug">
            Her takı, bir{' '}
            <em className="text-gold-gradient not-italic">hikâye</em> anlatır.
            <br />
            Sizinki benzersiz olsun.
          </h2>
          <div className="reveal reveal-delay-2 gold-line w-24 mx-auto mt-8" />
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left – image */}
          <div className="reveal">
            <div className="relative w-full h-[480px] md:h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=skilled%20master%20goldsmith%20artisan%20hands%20carefully%20crafting%20custom%20gold%20jewelry%20in%20luxury%20atelier%20workshop%2C%20close-up%20detailed%20craftsmanship%20macro%20photography%2C%20warm%20amber%20golden%20light%20from%20below%2C%20dark%20background%2C%20precision%20tools%2C%20elegant%20sophisticated%20atmosphere%2C%20cinematic%20quality&width=600&height=800&seq=3&orientation=portrait"
                alt="Sara Kuyumculuk üretim atölyesi"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-luxury-black/30 to-transparent" />
              {/* Badge */}
              <div className="absolute bottom-8 right-0 bg-luxury-black/90 border border-gold/40 p-6 max-w-[220px]">
                <p className="font-sans text-gold text-xs tracking-luxury uppercase mb-2">
                  Sara Kuyumculuk
                </p>
                <p className="font-serif text-white text-lg leading-snug">
                  Kişiye özel altın &amp; gümüş tasarımlar
                </p>
              </div>
            </div>
          </div>

          {/* Right – text */}
          <div className="flex flex-col gap-8">
            <h3 className="reveal font-serif text-3xl md:text-4xl text-white font-light leading-snug">
              SARA KUYUMCULUK,
              <br />
              <span className="text-gold">sadece sizin için</span> üretir.
            </h3>

            <p className="reveal reveal-delay-1 font-sans text-white/60 text-sm leading-loose">
              Atölyemizde hiçbir ürün rafta hazır beklemez. Her sipariş, her tasarım, her parça —
              tamamen sizin isteklerinizle hayata geçer. Altın, gümüş ve değerli taşlarla
              anlattığınız hikâyeyi sonsuza taşıyoruz.
            </p>

            <div className="reveal reveal-delay-2 gold-line w-16" />

            <div className="reveal reveal-delay-3 flex flex-col gap-6">
              {[
                {
                  title: 'Benzersiz Tasarım',
                  desc: 'Dünyada tek olan, yalnızca size ait bir takı.',
                },
                {
                  title: 'Usta İşçilik',
                  desc: 'Her parça, deneyimli goldsmith ustalarımız tarafından üretilir.',
                },
                {
                  title: 'Anlık İletişim',
                  desc: 'WhatsApp üzerinden tasarım sürecini birlikte yönetiriz.',
                },
              ].map((item, i) => (
                <div key={i} className="flex gap-4 group">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold group-hover:scale-150 transition-transform duration-300" />
                  </div>
                  <div>
                    <p className="font-sans text-white text-sm font-medium tracking-wide">
                      {item.title}
                    </p>
                    <p className="font-sans text-white/50 text-xs leading-relaxed mt-1">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="reveal reveal-delay-4">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="nofollow noreferrer"
                className="btn-gold inline-flex items-center gap-3 px-8 py-4 text-xs rounded-sm whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base" />
                Hemen Başla
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
